export default __webpack_public_path__ + "static/media/t6.23df522e.png";